module.exports = __webpack_public_path__ + "static/media/02-usa.d1ebf76c.png";